import { render, staticRenderFns } from "./ProgressReviewIndividual.vue?vue&type=template&id=5f99c473&scoped=true"
import script from "./ProgressReviewIndividual.vue?vue&type=script&lang=js"
export * from "./ProgressReviewIndividual.vue?vue&type=script&lang=js"
import style0 from "./ProgressReviewIndividual.vue?vue&type=style&index=0&id=5f99c473&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f99c473",
  null
  
)

export default component.exports